import { forwardRef } from 'react'
import { CrashGame } from '@/components/original/games/crash/CrashGame'
import { SlideGame } from '@/components/original/games/slide/SlideGame'
import { MineGame } from '@/components/original/games/mine/MineGame'
import { ChickenGame } from '@/components/original/games/chicken/ChickenGame'
import { BlackjackGame } from '@/components/original/games/blackjack/BlackjackGame'
import { BaccaratGame } from '@/components/original/games/baccarat/BaccaratGame'
import { RouletteGame } from '@/components/original/games/roulette/RouletteGame'
import { useDefaultCurrencyCode } from '@/hooks/use-default-currency'
import { cn } from '@/lib/utils'
import type { OriginalGame } from '@/types/original'

interface OriginalPlayHeroProps {
	game: OriginalGame
	isTheaterMode: boolean
}

export const OriginalPlayHero = forwardRef<HTMLDivElement, OriginalPlayHeroProps>(function OriginalPlayHero({ game, isTheaterMode }, ref) {
	const gameType = game.type.toLowerCase()
	const currencyCode = useDefaultCurrencyCode()

	switch (gameType) {
		case 'crash':
			return <CrashGame ref={ref} currencyCode={currencyCode} />
		case 'slide':
			return <SlideGame ref={ref} currencyCode={currencyCode} />
		case 'mine':
			return <MineGame ref={ref} currencyCode={currencyCode} />
		case 'chicken':
			return <ChickenGame ref={ref} currencyCode={currencyCode} />
		case 'blackjack':
			return <BlackjackGame ref={ref} currencyCode={currencyCode} />
		case 'baccarat':
			return <BaccaratGame ref={ref} currencyCode={currencyCode} />
		case 'roulette':
			return <RouletteGame ref={ref} currencyCode={currencyCode} />
	}

	const frameClassName = cn(
		'relative w-full scroll-mt-20 overflow-hidden rounded-2xl border border-border bg-card lg:scroll-mt-4',
		isTheaterMode ? 'aspect-[21/9] min-h-[620px]' : 'aspect-video min-h-[400px] sm:min-h-[520px] lg:min-h-[640px]',
	)

	return (
		<div ref={ref} className={frameClassName}>
			<div className='absolute inset-0 flex items-center justify-center bg-background'>
				<p className='text-sm font-medium text-muted-foreground'>{game.game_name}</p>
			</div>
		</div>
	)
})
